import axiosInstance from './axios';

const superAdminService = {
  login: async (credentials) => {
    const response = await axiosInstance.post('/institutes/login', credentials);
    return response.data;
  },

  // All other API calls will automatically include the token
  getDashboardStats: async () => {
    const response = await axiosInstance.get('/institutes/dashboard/stats');
    return response.data;
  },

  getProfile: async () => {
    const response = await axiosInstance.get('/institutes/profile');
    return response.data;
  },

  // Add more API calls as needed
};

export default superAdminService;